// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container[data-v-3d2e5d28] {
  width: 100%;
  height: 100%;
  position: relative;
}
.container > div[data-v-3d2e5d28] {
  width: 100%;
}
.container.full-screen[data-v-3d2e5d28] {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100% !important;
  z-index: 1888;
  background: #fff;
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
}
.container.full-screen > .content[data-v-3d2e5d28] {
  flex: 1;
  overflow: hidden;
}
.container.full-screen > .content[data-v-3d2e5d28] .tab-btn {
  height: 100% !important;
  overflow: auto;
}
.container.full-screen > .content[data-v-3d2e5d28] .left-right-box {
  height: 100% !important;
}
.container .full-screen-btn[data-v-3d2e5d28] {
  position: absolute;
  color: red;
  right: 37px;
  z-index: 88;
  top: 3px;
  padding: 0;
  font-size: 16px;
  font-weight: 600;
}
.label-content[data-v-3d2e5d28] {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  position: relative;
}
.label-content .rect[data-v-3d2e5d28] {
  display: inline-block;
  width: 6px;
  height: 14px;
  background-color: #006ffa;
  margin-right: 8px;
}
.label-content label[data-v-3d2e5d28] {
  color: #000;
  margin-right: 40px;
  font-weight: 600;
}
.label-content .line[data-v-3d2e5d28] {
  flex: 1;
  height: 1px;
  background-color: #3fa5dc;
}
.label-content .arrow[data-v-3d2e5d28] {
  display: flex;
  width: 14px;
  height: 14px;
  margin-left: 30px;
  margin-right: 20px;
  font-size: 28px;
  margin-top: -4px;
  color: #000;
}
.label-content .arrow i[data-v-3d2e5d28] {
  margin-top: -6px;
}
.content[data-v-3d2e5d28] {
  width: 100%;
  box-sizing: content-box;
}
`, "",{"version":3,"sources":["webpack://./src/components/LableContent/index.vue","webpack://./index.vue"],"names":[],"mappings":"AACA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACAF;ADHA;EAKI,WAAA;ACCJ;ADCE;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,uBAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;ACCJ;ADXE;EAYI,OAAA;EACA,gBAAA;ACEN;ADfE;EAeM,uBAAA;EACA,cAAA;ACGR;ADnBE;EAmBM,uBAAA;ACGR;AD7BA;EAgCI,kBAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,UAAA;EACA,eAAA;EACA,gBAAA;ACAJ;ADGA;EACE,WAAA;EACA,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,kBAAA;ACDF;ADJA;EAOI,qBAAA;EACA,UAAA;EACA,YAAA;EACA,yBAAA;EACA,iBAAA;ACAJ;ADXA;EAcI,WAAA;EACA,kBAAA;EACA,gBAAA;ACAJ;ADhBA;EAmBI,OAAA;EACA,WAAA;EACA,yBAAA;ACAJ;ADrBA;EAwBI,aAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;ACAJ;AD/BA;EAiCM,gBAAA;ACCN;ADGA;EACE,WAAA;EACA,uBAAA;ACDF","sourcesContent":["\n.container {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  > div {\n    width: 100%;\n  }\n  &.full-screen {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100% !important;\n    z-index: 1888;\n    background: #fff;\n    padding: 12px 16px;\n    display: flex;\n    flex-direction: column;\n    > .content {\n      flex: 1;\n      overflow: hidden;\n      ::v-deep .tab-btn {\n        height: 100% !important;\n        overflow: auto;\n      }\n      ::v-deep .left-right-box {\n        height: 100% !important;\n      }\n    }\n  }\n\n  .full-screen-btn {\n    position: absolute;\n    color: red;\n    right: 37px;\n    z-index: 88;\n    top: 3px;\n    padding: 0;\n    font-size: 16px;\n    font-weight: 600;\n  }\n}\n.label-content {\n  width: 100%;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  position: relative;\n  .rect {\n    display: inline-block;\n    width: 6px;\n    height: 14px;\n    background-color: #006ffa;\n    margin-right: 8px;\n  }\n  label {\n    color: #000;\n    margin-right: 40px;\n    font-weight: 600;\n  }\n  .line {\n    flex: 1;\n    height: 1px;\n    background-color: #3fa5dc;\n  }\n  .arrow {\n    display: flex;\n    width: 14px;\n    height: 14px;\n    margin-left: 30px;\n    margin-right: 20px;\n    font-size: 28px;\n    margin-top: -4px;\n    color: #000;\n    i {\n      margin-top: -6px;\n    }\n  }\n}\n.content {\n  width: 100%;\n  box-sizing: content-box;\n}\n",".container {\n  width: 100%;\n  height: 100%;\n  position: relative;\n}\n.container > div {\n  width: 100%;\n}\n.container.full-screen {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100% !important;\n  z-index: 1888;\n  background: #fff;\n  padding: 12px 16px;\n  display: flex;\n  flex-direction: column;\n}\n.container.full-screen > .content {\n  flex: 1;\n  overflow: hidden;\n}\n.container.full-screen > .content ::v-deep .tab-btn {\n  height: 100% !important;\n  overflow: auto;\n}\n.container.full-screen > .content ::v-deep .left-right-box {\n  height: 100% !important;\n}\n.container .full-screen-btn {\n  position: absolute;\n  color: red;\n  right: 37px;\n  z-index: 88;\n  top: 3px;\n  padding: 0;\n  font-size: 16px;\n  font-weight: 600;\n}\n.label-content {\n  width: 100%;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  position: relative;\n}\n.label-content .rect {\n  display: inline-block;\n  width: 6px;\n  height: 14px;\n  background-color: #006ffa;\n  margin-right: 8px;\n}\n.label-content label {\n  color: #000;\n  margin-right: 40px;\n  font-weight: 600;\n}\n.label-content .line {\n  flex: 1;\n  height: 1px;\n  background-color: #3fa5dc;\n}\n.label-content .arrow {\n  display: flex;\n  width: 14px;\n  height: 14px;\n  margin-left: 30px;\n  margin-right: 20px;\n  font-size: 28px;\n  margin-top: -4px;\n  color: #000;\n}\n.label-content .arrow i {\n  margin-top: -6px;\n}\n.content {\n  width: 100%;\n  box-sizing: content-box;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
